module.exports = __webpack_public_path__ + "static/media/Banner_KosaKata_Winner.c91d7f76.png";